module.exports = __webpack_public_path__ + "259c79d26532598099ba6c0a3c5dfd93.svg";